import React from 'react';
import curve from "../../assets/icons/curvyline.svg"; 
import heroImg from "../../assets/img/our-approach/our-approach-hero-img.png";

export default function Hero() {
  return (
    <> <section className='bg-white'>
				<div className='text-center space-y-2 md:pt-40 pt-32 pb-16 w-[90%] max-w-[1440px] mx-auto text-[#002814]'>
					<h1 className='md:text-[64px]/[79px] text-[40px]/[49px] lg:tracking-[-2px] tracking-[-1.72px] font-medium'>
						SYNERGYCARE PROGRAMMATIC 
						<br />
						FRAMEWORK
					</h1>
					<img
						src={curve}
						alt='Icon 1'
						className='absolute lg:top-40 lg:right-20 top-0 right-0'
					/>

					{/* Paragraph Section */}
					<p className='max-w-[1087px] w-full mx-auto  md:text-xl/[30px] text-xs/[21px]'>
						Synergy Care Foundation is a nonprofit organization with offices in Maryland and Washington, D.C. Our mission is to build a resilient community for underserved populations—including middle-class earners, low-income  individuals, the homeless, and other vulnerable groups—across Maryland, Virginia, and Washington, D.C. This framework outlines our comprehensive strategy for delivering essential services in healthcare, social services, housing, employment, economic empowerment, and community advocacy. Our approach is informed by robust data on demographic composition, service access gaps, and geographic disparities.
					</p>
      </div>
      
    </section>
      <section className='bg-[#FAFFF1] pb-7'>
        <img src={heroImg} alt='Hero' className=' w-[90%] max-w-[1440px] mx-auto rounded-[30px]' />
      </section>
    </>
   
  )
}